import React from 'react'
import { GridItem } from '@deal/components'
import { camelCase } from 'lodash'
import SidebarAwareGrid from '#src/components/SidebarAwareGrid'
import Tooltip from '#src/components/ProductPage/Tooltip'
import {
  SellableSpecificationFragment,
  SellableFormattedVariant,
  DepartmentType
} from '#src/generated/graphql'
import styles from './styles.css'

interface SpecificationTableProps {
  header?: string
  specifications: SellableSpecificationFragment[]
  department?: DepartmentType
  variants: SellableFormattedVariant[]
}

const SpecificationTable: React.SFC<SpecificationTableProps> = ({
  specifications,
  header,
  department,
  variants
}) => {
  return (
    <>
      {header && (
        <SidebarAwareGrid>
          <GridItem col={2}>
            <div className={styles.header}>{header}</div>
          </GridItem>
        </SidebarAwareGrid>
      )}
      <div className={styles.table}>
        <SidebarAwareGrid>
          {department === DepartmentType.GOLF &&
            variants.map(variant => {
              if (variant.displayName && variant.displayValueHtml) {
                return (
                  <GridItem col={2} key={variant.name} className={styles.gridItem}>
                    <div className={styles.tableRow}>
                      <div className={styles.tableRowLabel}>
                        {variant.displayName}
                        {variant.name === 'flexType' && (
                          <span className={styles.tooltip}>
                            <Tooltip reference={'flexType'} fill="black" title={'Flex Type'} />
                          </span>
                        )}
                      </div>
                      <div className={styles.tableRowValue}>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: variant.displayValueHtml
                          }}
                        />
                        {variant.name === 'flexType' && (
                          <span className={styles.tooltip}>
                            <Tooltip
                              reference={camelCase(variant.value)}
                              fill="black"
                              place="top"
                              title={variant.displayValueHtml}
                            />
                          </span>
                        )}
                      </div>
                    </div>
                  </GridItem>
                )
              }
            })}

          {specifications.map(spec => {
            if (spec.valueHtml && spec.name) {
              return (
                <GridItem col={2} key={spec.name} className={styles.gridItem}>
                  <div className={styles.tableRow}>
                    <div className={styles.tableRowLabel}>{spec.name}</div>
                    <div
                      className={styles.tableRowValue}
                      dangerouslySetInnerHTML={{
                        __html: spec.valueHtml
                      }}
                    />
                  </div>
                </GridItem>
              )
            }
          })}
        </SidebarAwareGrid>
      </div>
    </>
  )
}

export default SpecificationTable
